<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
        {{ erro }}
      </div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>location_city</mat-icon></div>
          <mat-card-title>Bairros</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe o filtro e clique em <strong>Consultar</strong> para listar os bairros.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="neighborhoods" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let neighborhood">{{ neighborhood.id }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let neighborhood">{{ neighborhood.name }}</td>
            </ng-container>
            <ng-container matColumnDef="excluir">
              <th mat-header-cell *matHeaderCellDef>Excluir</th>
              <td mat-cell *matCellDef="let neighborhood" (click)="$event.stopPropagation()">
                <button (click)="openDialog(neighborhood.id)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="editar">
              <th mat-header-cell *matHeaderCellDef>Editar</th>
              <td mat-cell *matCellDef="let neighborhood" (click)="$event.stopPropagation()">
                <button (click)="editar(neighborhood.id)" mat-icon-button color="accent">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>

          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
          </mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
